import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import defaultAvatar from "../../../assets/images/avatar/1.png";
import { useMutation } from "@apollo/client";
import { BLOCK_MEMBER } from "../../../graphql/mutations/message";
import { updateCurrentChatBlock } from "../redux/chatSlice";
import { BlockIcon, UnBlockIcon } from "../../../constants/icon_path";
import { showErrorToast } from "../../../components/common/CustomErrorMessage";

const ChatHeader = ({ refetchChatRoom }) => {
  const dispatch = useDispatch();
  const chat = useSelector((state) => state.chat);
  const { currentChat } = chat;

  const avatar = currentChat?.profileImage ?? defaultAvatar;

  const [blockMember] = useMutation(BLOCK_MEMBER, {
    onCompleted: (data) => {
      if (data.blockMember) {
        dispatch(updateCurrentChatBlock(data.blockMember.isBlocked));
        refetchChatRoom();
      }
    },
    onError: (err) => {
      showErrorToast(err.message);
    },
  });

  const handleBlock = async (memberId, isBlocked) => {
    const answer = window.confirm(
      isBlocked
        ? "ຕ້ອງການບ໋ອກລູກຄ້າາຄົນນີ້ບໍ?"
        : "ຕ້ອງການປົດບ໋ອກລູກຄ້າາຄົນນີ້ບໍ?",
    );
    if (answer) {
      await blockMember({ variables: { memberId, isBlocked } });
    }
  };

  return (
    <div className="chat_header">
      <div className="header_item">
        <div className="d-flex">
          <div className="avatar-sm m-2">
            <img src={avatar} alt="avatar" />
          </div>
          <p className="m-2">
            {currentChat.nickname} {`(${currentChat.userId})`}
          </p>
        </div>
        {currentChat.isBlocked ? (
          <Button
            variant="success"
            onClick={() => handleBlock(currentChat.memberId, false)}
          >
            <UnBlockIcon size={20} /> ປົດບ໋ອກ
          </Button>
        ) : (
          <Button
            variant="danger"
            onClick={() => handleBlock(currentChat.memberId, true)}
          >
            <BlockIcon size={20} /> ບ໋ອກ
          </Button>
        )}
      </div>
    </div>
  );
};

export default ChatHeader;
